import type { UserRegistrationType } from 'src/types/userRegistrationType';
import { isEmailConsentRequired } from 'src/views/Onboarding/utils';

// https://github.com/SEEK-Jobs/forms-ui#validation
interface ValidationParams {
  value: any; // the current value of the field
  validatorProps: Record<string, any>; // contextual props passed to field
  formValues: Record<string, any>; // object containing the current form state
}

interface Validator {
  getErrorMessage(params: ValidationParams): Promise<string>;
  test(params: ValidationParams): boolean;
}

export const optional = (validator: Validator): Validator => ({
  getErrorMessage: validator.getErrorMessage,
  test: (params) =>
    params.value === undefined || params.value === ''
      ? true
      : validator.test(params),
});

export const abnLength = {
  getErrorMessage: () => Promise.resolve('ABN must be 11 Numbers'),
  test: ({
    value,
    validatorProps: { length },
  }: {
    value: any;
    validatorProps: { length: number };
  }) => (value ? value.length === length && !isNaN(+Number(value)) : true),
};

export const numerical = {
  getErrorMessage: () => Promise.resolve('Field must only have numbers'),
  test: ({ value }: { value: any }) => (value ? !isNaN(+Number(value)) : true),
};

export const hasConsented = {
  // The consent checkbox is not mandatory for buyers and Private Sellers
  test: ({
    value,
    validatorProps: { userRegistrationType },
  }: {
    value: boolean;
    validatorProps: { userRegistrationType: UserRegistrationType };
  }) => (isEmailConsentRequired(userRegistrationType) ? value : true),
  getErrorMessage: () =>
    Promise.resolve('To create an account, you must agree to the above terms.'),
};
